import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import RegisterOther from "../RegisterOtherUser";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  ButtonOther,
  ButtonNext,
  Container,
  LeftAlignedTextBlock,
  ContactInfo,
} from "./styles";

const NoExams = ({ cpf }) => {
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const whatsappMessage = `Olá! Meus exames não foram vinculados automaticamente na Área do Paciente. Segue meu CPF para verificação: ${cpf}`;
  const encodedMessage = encodeURIComponent(whatsappMessage);
  const whatsappLink = `https://wa.me/5547991153595?text=${encodedMessage}`;
  const handleOpenRegisterModal = () => {
    setShowRegisterModal(true);
  };
  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
  };

  return (
    <Container>
      <h2 style={{ color: "#0c2b6eee", fontWeight: 650 }}>
        Exames não encontrados
      </h2>
      {showRegisterModal && (
        <RegisterOther onClose={handleCloseRegisterModal} />
      )}

      <LeftAlignedTextBlock>
        <h5>
          Não localizamos exames associados diretamente aos dados fornecidos no
          momento do seu cadastro. Isso pode ocorrer por dois motivos:
        </h5>
      </LeftAlignedTextBlock>

      <LeftAlignedTextBlock>
        <ul>
          <li>
            <strong>Você é o paciente:</strong> Pode haver divergências ou
            ausência de informações nos arquivos dos exames que impedem a
            vinculação automática. Por gentileza, entre em contato com nossa
            equipe ou compareça à recepção para que possamos ajudá-lo a
            localizar seus exames com segurança.
          </li>
          <li style={{ marginTop: "10px" }}>
            <strong>Você é o responsável legal pelo paciente:</strong> Se você
            realizou o cadastro com seus próprios dados, será necessário
            informar os dados do paciente e anexar uma autorização para acesso
            aos exames. Clique no botão abaixo para iniciar este processo.
          </li>
        </ul>
      </LeftAlignedTextBlock>

      <ButtonOther onClick={handleOpenRegisterModal}>
        Solicitar Acesso como Responsável Legal
        <FontAwesomeIcon icon={faUsers} style={{ marginLeft: "10px" }} />
      </ButtonOther>

      <LeftAlignedTextBlock>
        <h5>
          Estamos aqui para ajudar. Se tiver qualquer dúvida ou precisar de
          apoio, entre em contato conosco pelos canais abaixo:
        </h5>
      </LeftAlignedTextBlock>

      <ContactInfo>
        <div>
          <p>
            <strong>Telefone:</strong> (47) 99115-3595
            <br />
            <strong>Email:</strong> cedap@cedap.com.br
          </p>
          <p>
            <strong>Endereço:</strong> Rua Mário Lobo 61, sala 7 Térreo,
            Joinville - SC
            <br />
            <strong>Horário de atendimento:</strong> Segunda à sexta - das 7:00
            às 18:30
          </p>

          <ButtonNext
            as="a"
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Atendimento via WhatsApp
            <FontAwesomeIcon
              icon={faWhatsapp}
              style={{ marginLeft: 8, fontSize: "20px" }}
            />
          </ButtonNext>
        </div>
      </ContactInfo>
    </Container>
  );
};

export default NoExams;
